export const aboutSection = `
    <section class="py-16 w-full lg:w-[90%] mx-auto mt-12">
      <div
        class="text-center max-w-3xl mx-auto px-4"
        data-aos="fade-up"
        data-aos-duration="600"
      >
        <h2
          class="text-3xl md:text-5xl font-[500] text-gray-900 mb-6 leading-16"
          data-aos="fade-up"
        >
          About <span class="text-blue-700">Us</span>
        </h2>
        <div
          class="flex justify-center mb-6"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fd4e1030e6a4ef583f3fdd_solutions-plus.svg"
            alt="Solutions Plus"
            class="h-auto max-w-full"
          />
        </div>
        <p
          class="text-lg text-gray-900 mb-10"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          We are a Full-Stack institutional debt-raising platform that <br />
          offers solutions to all stakeholders.
        </p>
      </div>
      <!-- Floating Images -->
      <div class="relative mt-0 hidden lg:block">
        <img
          src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/67013da7aeea15a9f6e8a81e_inner-pattern-1.png"
          class="absolute -top-60 left-10 transition-all duration-1000 ease-in-out"
          data-aos="fade-down"
        />
        <img
          src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/67013da7aeea15a9f6e8a81e_inner-pattern-1.png"
          class="absolute bottom-10 right-10 transition-all duration-1000 ease-in-out"
          data-aos="fade-up"
          data-aos-delay="700"
        />
      </div>
      <div
        class="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-3"
        data-aos="fade-up"
        data-aos-duration="600"
      >
        <div>
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fe75d6947565065ef5e7fb_about-img-1.png"
            alt="ibankey"
            class="rounded-2xl w-md h-100 flex justify-center"
          />
        </div>
        <div class="flex justify-center items-center">
          <img
            src="https://ibankeycdn.azureedge.net/cdnfiles/website/ibankey-team/team2.jpg"
            alt="ibankey"
            class="rounded-2xl w-md h-80"
          />
        </div>
        <div class="flex justify-center items-center">
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fe75f0e6b6f7f81e3033f9_about-img-3.png"
            alt="ibankey"
            class="rounded-2xl w-md h-100 flex justify-center"
          />
        </div>
<div class="w-full max-w-lg aspect-[3/4] overflow-hidden rounded-2xl">
  <img
    src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/teamMember.jfif"
    class="w-full h-full object-cover"
    alt="ibankey"
  />
</div>

      </div>
      <!-- our mission -->
      <div class="mt-10">
        <div
          class="flex items-center justify-center text-center gap-4 text-blue-700 border w-40 mx-auto py-2 mb-6 rounded-full"
        >
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fbef0a93a0d581585d946b_feature-mini-title-icon.svg"
            alt="ibankey"
          />
          <p class="text-lg">Our Mission</p>
        </div>
        <div
          class="flex flex-col lg:flex-row bg-[#f8fbff] p-5 gap-7"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div class="w-full sm:w-full md:w-full lg:w-1/2 mx-auto">
            <img
              src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/ourMission.avif"
              alt="ibankey"
              class="rounded-2xl w-full h-[380px]"
            />
          </div>
          <div class="w-full lg:w-1/2">
            <p class="text-lg font-semibold text-gray-700">
              As a leading provider of innovative finance software, we're
              dedicated to empowering businesses like yours to achieve their
              financial goals.
            </p>
            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">
                Business Growth and Efficiency
              </p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              Financial opportunities should be inclusive to all. We imagine a
              world where everyone has access to funds to grow their businesses,
              regardless of their stage, location, size, and background, in an
              affordable, convenient, and transparent way.
            </p>

            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">Technological Innovation</p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              Leading the way in financial technology innovation to empower
              businesses.
            </p>
          </div>
        </div>
      </div>

      <!-- our Vision -->
      <div class="mt-10">
        <div
          class="flex items-center justify-center text-center gap-4 text-blue-700 border w-40 mx-auto py-2 mb-6 rounded-full"
        >
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fbef0a93a0d581585d946b_feature-mini-title-icon.svg"
            alt="ibankey"
          />
          <p class="text-lg">Our Vision</p>
        </div>
        <div
          class="flex flex-col lg:flex-row bg-[#f8fbff] p-5 gap-7"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div class="w-full sm:w-full md:w-full lg:w-1/2">
            <img
              src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/ourVision.png"
              alt="ibankey"
              class="rounded-2xl w-full h-full h-[400px] lg:h-[600px]"
            />
          </div>
          <div class="w-full lg:w-1/2">
            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">Reinvent Fund Raising</p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              We are a full-spectrum technology platform that delivers on
              fundraising in a faster, more efficient, and effective way.
            </p>

            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">
                Deliver an experience which is class-apart
              </p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              Accessing funds should be faster and seamless. We are on a mission
              to make borrowing and fund raising simple and accessible to all,
              backed by the best technology and a transparent approach,
              supported by a driven team.
            </p>

            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">Level playing field for All</p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              We've built a platform that removes inefficiencies, keeps costs
              low, and opens up immense possibilities to provide a level playing
              field for all businesses.
            </p>

            <div class="flex gap-3 items-start mt-10">
              <div
                class="w-8 h-8 bg-blue-800 rounded-full text-white text-sm flex items-center justify-center shrink-0 mb-3"
              >
                <i class="fa-solid fa-check"></i>
              </div>
              <p class="text-lg font-semibold">Do what is right, Always</p>
            </div>
            <p class="text-gray-600 text-sm font-[500]">
              We believe not only in delivery but also in doing things the right
              way. We are resetting the governance standard for the industry and
              developing ethical and responsible ways for raising debt.
            </p>
          </div>
        </div>
      </div>

      <!-- our Culture -->
      <div class="mt-10" data-aos="fade-up" data-aos-duration="600">
        <div
          class="flex items-center justify-center text-center gap-4 text-blue-700 border w-40 mx-auto py-2 mb-6 rounded-full"
        >
          <img
            src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/66fbef0a93a0d581585d946b_feature-mini-title-icon.svg"
            alt="ibankey"
          />
          <p class="text-lg">Our Culture</p>
        </div>
        <div class="flex flex-wrap justify-center gap-6 p-6 bg-white">
          <!-- Card 1 -->
          <a href="./culture.html">
            <div
              class="w-72 transform rotate-[-4deg] shadow-lg hover:rotate-[-2deg] transition duration-300 bg-white hover:border-2 hover:border-purple-600"
            >
              <img
                src="https://ibankeycdn.azureedge.net/cdnfiles/website/ibankey-team/team1.jpg"
                alt="ibankey"
              />
              <div class="p-4">
                <h2 class="font-semibold">Our Culture</h2>
                <p class="text-sm text-gray-600">
                 At ibankey, we cultivate a culture of innovation, trust, and collaboration empowering our teams to think boldly, solve real financial challenges, and grow together in a purpose-driven environment.
                </p>
              </div>
            </div>
          </a>

          <!-- Card 2 -->
          <a href="./team-lunch.html">
          <div
            class="w-72 transform rotate-[2deg] shadow-lg hover:rotate-0 transition duration-300 bg-white hover:border-2 hover:border-purple-600"
          >
            <img
              src="https://ibankeycdn.azureedge.net/cdnfiles/website/Event/ibankey-team6.jpg"
              alt="ibankey"
            />
            <div class="p-4">
              <h2 class="font-semibold">Team Lunch</h2>
              <p class="text-sm text-gray-600">
             Join us for a fun-filled team lunch where delicious food meets great conversations. It’s the perfect chance to relax, laugh, and connect with your teammates outside work. Don’t miss out on this delightful break—we can’t wait to see you!
              </p>
            </div>
          </div>
          </a>

          <!-- Card 3 -->
          <div
            class="w-72 transform rotate-[-3deg] shadow-lg hover:rotate-[-1deg] transition duration-300 bg-white hover:border-2 hover:border-purple-600"
          >
            <img
              src="https://ibankeycdn.azureedge.net/cdnfiles/website/Event/ibankey-team1.jpg"
              alt="ibankey"
            />
            <div class="p-4">
              <h2 class="font-semibold">Holi Celebration </h2>
              <p class="text-sm text-gray-600">
              Join us for a joyful Holi celebration filled with colors, music, laughter, and festive treats. Let’s come together and make vibrant memories with the team!
              </p>
            </div>
          </div>

          <!-- Card 4 -->
          <div
            class="w-72 transform rotate-[4deg] shadow-lg hover:rotate-[2deg] transition duration-300 bg-white hover:border-2 hover:border-purple-600"
          >
            <img
              src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/website/Event/ibankey-team2.jfif"
              alt="ibankey"
            />
            <div class="p-4">
              <h2 class="font-semibold">Diwali Celebration</h2>
              <p class="text-sm text-gray-600">
                Wishing you a sparkling Diwali filled with joy, light, and laughter! May this festival bring success, happiness, and prosperity to you and your loved ones. Let’s celebrate together with warmth, sweets, and festive cheer!  
              </p>
            </div>
          </div>

          <!-- Card 5 -->
          <div
            class="w-72 transform rotate-[-2deg] shadow-lg hover:rotate-0 transition duration-300 bg-white hover:border-2 hover:border-purple-600"
          >
            <img
              src="https://ibankeycdn.azureedge.net/cdnfiles/website/ibankey-team/team5.jpg"
              alt="ibankey"
            />
            <div class="p-4">
              <h2 class="font-semibold">ibankey</h2>
              <p class="text-sm text-gray-600">
                ibankey is a digital lending platform dedicated to simplifying financial access for individuals and businesses. With smart technology, seamless processes, and trusted partners, ibankey offers fast, transparent, and secure loan solutions tailored to meet your financial needs effectively.
              </p>
            </div>
          </div>

          <!-- Card 6 -->
          <div
            class="w-72 transform rotate-[3deg] shadow-lg hover:rotate-[1deg] transition duration-300 bg-white hover:border-2 hover:border-purple-600"
          >
            <img
              src="https://ibankeycdn.azureedge.net/cdnfiles/website/ibankey-team/team1.jpg"
              alt="Team Party"
            />
            <div class="p-4">
              <h2 class="font-semibold">Team Parties</h2>
              <p class="text-sm text-gray-600">
               Celebrate the spirit of teamwork with a fun-filled team party! Enjoy good food, laughter, games, and great company. It's the perfect time to relax, connect, and create unforgettable memories together. Let’s make it a night to remember!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
`;
